import { createSelector } from '@reduxjs/toolkit';

import { MonogramState } from '@definitions/monogram.types';

import { GlobalState } from '../createStore';

export const selectMonogramDomain = (state: GlobalState) => state.monogram;

export const selectMonograms = createSelector(selectMonogramDomain, (state: MonogramState) => state.monograms);
